module.exports = __webpack_public_path__ + "static/media/industryExpertise.e971c29f.png";